import { render, staticRenderFns } from "./Noticeread.vue?vue&type=template&id=f0e5776e&scoped=true&"
import script from "./Noticeread.vue?vue&type=script&lang=js&"
export * from "./Noticeread.vue?vue&type=script&lang=js&"
import style0 from "./Noticeread.vue?vue&type=style&index=0&id=f0e5776e&prod&scoped=true&lang=css&"
import style1 from "./Noticeread.vue?vue&type=style&index=1&id=f0e5776e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e5776e",
  null
  
)

export default component.exports